import getNamespacedObject from '@/store/utils/getNamespacedObject';
import namespace from './namespace';

export const createCompanyFiles = 'create/company-files';
export const updateCompanyFiles = 'update/company-files';
export const addProjectFile = 'add/project-file';
export const deleteProjectFile = 'delete/project-file';
export const changeProjectFileStatus = 'change/project-file-status';
export const changeCodeOfConductStatus = 'change/code-of-conduct-status';
export const uploadProjectFile = 'upload/project-file';
export const deleteLegacyFiles = 'delete/legacy-files';
export const syncCompanyFilesList = 'sync/company-files-list';
export const syncCompanyFiles = 'sync/company-files';

const actions = {
  createCompanyFiles,
  updateCompanyFiles,
  addProjectFile,
  deleteProjectFile,
  changeProjectFileStatus,
  changeCodeOfConductStatus,
  uploadProjectFile,
  deleteLegacyFiles,
  syncCompanyFilesList,
  syncCompanyFiles,
};

export const namespacedActions = getNamespacedObject(namespace, actions);

export default actions;



// WEBPACK FOOTER //
// ./src/store/companyFiles/actionTypes.js